export default __webpack_public_path__ + "static/emailrecieved-1f0e47aec516bffc020cd0f1dcdbb239.gif";